import D3Asset from '@/editor/assets/d3.asset'

export default class ImageAsset extends D3Asset {
  constructor(uuid) {
    super(uuid)
    this._type = 'image'
  }

  get resizable() {
    return true
  }

  async loadFromFile(file) {
    await this._loadFromFile(file)
    this._asset.meta.name = file.name
    await this.loadInfo()
    this._asset.ready = true
    this.emit('ready')
  }
  getInfo() {
    const img = new Image()
    img.src = URL.createObjectURL(this._asset.blob)
    img.onerror = (err) => {
      this.dbg.warn('img asset error', err)
      this.emit('asset.error', err)
      return false
    }

    return img
  }

  image2thumbnail(img, type = 'image/png') {
    return new Promise((resolve) => {
      const width = img.naturalWidth || img.width || 1
      const height = img.naturalHeight || img.height || 1
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        resolve(null)
        return
      }
      ctx.drawImage(img, 0, 0, width, height)
      canvas.toBlob((blob) => {
        resolve(blob || null)
      }, type)
    })
  }

  loadInfo() {
    return new Promise((resolve, reject) => {
      const img = new Image()
      const src = URL.createObjectURL(this._asset.blob)
      img.src = src
      img.onerror = (err) => {
        URL.revokeObjectURL(src)
        this.dbg.warn('img asset error', err)
        this.emit('asset.error', err)
        reject(err)
      }
      // video.addEventListner('canplay', () => {
      img.onload = async () => {
        this._asset.meta = {
          ...this._asset.meta,
          width: img.naturalWidth || img.width,
          height: img.naturalHeight || img.height,
        }
        try {
          this._asset.thumbnail = await this.image2thumbnail(img)
        } catch (err) {
          this.dbg.warn('img asset thumbnail error', err)
        }
        URL.revokeObjectURL(src)
        resolve()
      }
    })
  }

  initAnimation(settings, zeroFrame) {
    return this.initAnimationD2(settings, zeroFrame)
  }

  color() {
    return '#09dee7'
  }

  icon() {
    return ['fas', 'image']
  }
}
